import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
  RedirectCommand,
  Router,
} from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DynamicScriptLoaderService } from 'src/app/services/dynamicScriptLoaderService.service';
import { HomeService } from 'src/app/services/home.service';
import { SetLocalizeService } from 'src/app/services/set-localize.service';
import { SpinnerOverlayService } from 'src/app/shared/spinner/spinner-overlay.service';
import { sanitizeQueryParamKey } from 'src/app/services/event-protection.guard';

@Injectable({
  providedIn: 'root',
})
export class EventProtectionResolver implements Resolve<any | RedirectCommand> {
  constructor(
    private homeService: HomeService,
    private spinnerOverlayService: SpinnerOverlayService,
    private dynamicScript: DynamicScriptLoaderService,
    private setLocalizeService: SetLocalizeService,
    private readonly commonService: CommonService,
    private readonly router: Router
  ) {}
  async resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<any> {
    this.spinnerOverlayService.startSpinning();
    const queryParams = _route.queryParams || {};
    const applicationId =
      queryParams['applicationId'] ||
      _route.params['appId'] ||
      this.commonService.getApplicationId();
    if (applicationId) {
      this.commonService.setApplicationId(String(applicationId));
    }

    const showId =
      queryParams['showId']
        ? Number(queryParams['showId'])
        : (_route.params['id'] ? Number(_route.params['id']) : Number(this.commonService.getShowId()));
    if (showId) {
      this.commonService.setShowId(String(showId));
    }

    try {
      const [ticketOverRideResponse, protectionResponse] = await Promise.all([
        this.homeService.getTicketWindowOverridesDetails(showId).toPromise(),
        this.homeService.getEventProtectinType(showId).toPromise().catch(() => null),
      ]);

      const currentProtectionType =
        protectionResponse &&
        protectionResponse.isSuccessful &&
        protectionResponse.data &&
        protectionResponse.data.protectionType !== undefined
          ? Number(protectionResponse.data.protectionType)
          : null;

      // If protection was turned off (0 / None), redirect directly to tickets screen preserving query params (promocode, utm, etc.)
      if (currentProtectionType === 0 && applicationId && showId) {
        this.spinnerOverlayService.stopSpinning();
        try {
          sessionStorage.setItem('eventProtectionValidatedShow', String(showId));
        } catch (_) {}
        const cleanQueryParams: Record<string, any> = {};
        Object.entries(queryParams).forEach(([rawKey, val]) => {
          const key = sanitizeQueryParamKey(rawKey);
          if (
            key &&
            key !== 'eventProtection' &&
            key !== 'showId' &&
            key !== 'applicationId'
          ) {
            cleanQueryParams[key] = val;
          }
        });
        const urlTree = this.router.createUrlTree(['/', applicationId, showId], {
          queryParams:
            Object.keys(cleanQueryParams).length > 0
              ? cleanQueryParams
              : undefined,
        });
        return new RedirectCommand(urlTree);
      }

      if (
        ticketOverRideResponse &&
        ticketOverRideResponse.isSuccessful &&
        ticketOverRideResponse.data
      ) {
        this.dynamicScript.loadCss(
          ticketOverRideResponse.data.ticketWindowOverridesCSS,
          'ltrTicketwindowOverridesCSS'
        );
        await this.setLocalizeService.setLocalizationKeys(
          ticketOverRideResponse.data.ticketWindowOverridesJS
        );
        this.spinnerOverlayService.stopSpinning();
        const obj = {
          eventTitle: ticketOverRideResponse.data.eventTitle,
          sucess: true,
          currentProtectionType,
        };
        return obj;
      }
      this.spinnerOverlayService.stopSpinning();
      return {
        eventTitle: '',
        sucess: true,
        currentProtectionType,
      };
    } catch (error) {
      this.spinnerOverlayService.stopSpinning();
      const obj = {
        eventTitle: '',
        sucess: true,
      };
      return obj;
    }
  }
}
